import * as  React from 'react';
import { Balloon } from '@alifd/next';
import { store,EVENT } from '../../store'
import './index.scss';

const { Fragment,useContext } = React;

interface itemProps {
    nameType: string;
    name: string;
    logoUrl: string;
    sellingPoint: string;
    introduction: string;
    verifiedFixText: string;
}
interface propTypes {
    i18n: any;
    certification: {
        certType: string;
        certificationInfo: [itemProps]
    };
}

export default function Index ( props: propTypes ) {
    const { i18n,certification } = props;
    if (!certification) return null;
    const { certType,certificationInfo } = certification;
    if ( !certType || !certificationInfo ) return null;

    const { dispatch } = useContext( store )

    const certificateMap = {} as any;

    // 激活主图弹窗
    const handClick = ( index: number ) => {
        dispatch( {
            type: EVENT.certification,
            payload: index
        } );
    };

    const renderMore = () => {
        return (
            <a href="#" onClick={e => {
                e.preventDefault();
                handClick( 0 );
            }}>
                {i18n['benefits.more']}
            </a>
        );
    };

    certificationInfo.forEach( item => {
        certificateMap[item.nameType] = item;
    } );

    return ( <Fragment>
        {certType === 'PRODUCT' && (
            <div className="certificate-item">
                {Object.values( certificateMap )
                    .slice( 0,5 )
                    .map( ( item: itemProps,index: number ) => (
                        <Balloon
                            key={index}
                            trigger={
                                <img
                                    onClick={e => {
                                        e.preventDefault();
                                        handClick( index );
                                    }}
                                    key={item.name}
                                    src={item.logoUrl}
                                />
                            }
                            align="tr"
                        >
                            {item.introduction}
                        </Balloon>
                    ) )}
                {renderMore()}
            </div>
        )}
        {certType === 'INSPECTION_REPORT' &&
            certificationInfo.slice( 0,1 ).map( ( item,index ) => (
                <div className="certificate-item" key={item.sellingPoint}>
                    <img
                        className="certifacate"
                        onClick={e => {
                            e.preventDefault();
                            handClick( index );
                        }}
                        src="//img.alicdn.com/imgextra/i1/O1CN01nVcKPh1xxd2w77tv7_!!6000000006510-2-tps-28-32.png"
                    />
                    <span>{item.verifiedFixText}</span>
                    <strong className="name">{item.sellingPoint}</strong>
                    {renderMore()}
                </div>
            ) )}
    </Fragment>
    );
}
